import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { Component } from 'react';
import { MdClose, MdError, MdSend } from 'react-icons/md';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default class ApuracaoEmailDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            emails: [],
            emailAtual: '',
            erro: '',
            enviando: false
        };
    }

    componentDidUpdate(prevProps) {
        // Se a prop 'error' mudar para true ou se o diálogo for reaberto com erro, reseta o estado de 'enviando'
        if (this.props.error && !prevProps.error && this.state.enviando) {
            this.setState({ enviando: false });
        }
    }

    adicionarEmail = () => {
        let email = this.state.emailAtual.trim();
        if (!email) return;

        if (!EMAIL_REGEX.test(email)) {
            this.setState({ erro: 'E-mail inválido' });
            return;
        }
        if (this.state.emails.includes(email)) {
            this.setState({ erro: 'E-mail já adicionado', emailAtual: '' });
            return;
        }

        this.setState(prev => ({
            emails: [...prev.emails, email],
            emailAtual: '',
            erro: ''
        }));
    }

    removerEmail = (email) => {
        this.setState(prev => ({ emails: prev.emails.filter(e => e !== email) }));
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            this.adicionarEmail();
        }
    }

    handleCancelar = () => {
        this.setState({ emails: [], emailAtual: '', erro: '', enviando: false });
        this.props.onClose();
    }

    handleEnviar = () => {
        let { assunto, corpo, uuid } = this.props;
        if (this.state.emails.length === 0) return;

        this.setState({ enviando: true });

        if (this.props.onEnviar) {
            this.props.onEnviar({ to: this.state.emails, subject: assunto, body: corpo, uuid });
        }
    }

    render() {
        let { open, assunto, corpo, error } = this.props;
        let { emails, emailAtual, erro, enviando } = this.state;

        return (
            <Dialog open={open ?? true} onClose={enviando ? undefined : this.handleCancelar} fullWidth maxWidth="sm">
                <DialogTitle>Enviar por e-mail</DialogTitle>
                <DialogContent>
                    <Stack gap={2} mt={0.5}>
                        <TextField
                            label="Adicionar e-mail"
                            placeholder="nome@empresa.com"
                            size="small"
                            fullWidth
                            value={emailAtual}
                            onChange={(e) => this.setState({ emailAtual: e.target.value, erro: '' })}
                            onKeyDown={this.handleKeyDown}
                            onBlur={this.adicionarEmail}
                            error={!!erro}
                            helperText={erro || 'Pressione Enter para adicionar'}
                            disabled={enviando}
                        />

                        <Stack direction="row" gap={1} flexWrap="wrap">
                            {emails.map(email => (
                                <Chip
                                    key={email}
                                    label={email}
                                    size="small"
                                    onDelete={enviando ? undefined : () => this.removerEmail(email)}
                                />
                            ))}
                            {emails.length === 0 &&
                                <Typography fontSize={12} color="#9ca3af">Nenhum e-mail adicionado</Typography>
                            }
                        </Stack>

                        <Stack bgcolor="#f5f7fa" borderRadius={2} p={1.5} gap={0.5}>
                            <Typography fontSize={12}><b>Assunto:</b> {assunto}</Typography>
                            <Typography fontSize={12}><b>Mensagem:</b> {corpo}</Typography>
                        </Stack>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
                    {error ? (
                        <Stack direction="row">
                            <Box color="#d32f2f" mr={1}><MdError /></Box>
                            <Typography color="error" fontSize={13} fontWeight="medium">
                                Falha no envio!
                            </Typography>
                        </Stack>
                    ) : (
                        <div />
                    )}

                    <Stack direction="row" gap={1}>
                        <Button startIcon={<MdClose />} onClick={this.handleCancelar} disabled={enviando} color="inherit">
                            Cancelar
                        </Button>
                        <Button
                            startIcon={<MdSend />}
                            onClick={this.handleEnviar}
                            disabled={emails.length === 0 || enviando}
                            variant="contained"
                            disableElevation
                            sx={{ bgcolor: '#0A57A3', '&:hover': { bgcolor: '#084684' } }}
                        >
                            {enviando ? 'Enviando...' : 'Enviar'}
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        );
    }
}